import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import * as serviceWorker from 'serviceWorker';
import App from 'App';
import { store } from 'store';
import 'assets/scss/style.scss';
import { information } from 'services/auth';
import { clearSession, isTokenValid } from 'utils/session';

const renderApp = () => {
  ReactDOM.render(
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>,
    document.getElementById('root')
  );
};

const handleToken = async () => {
  const token = localStorage.getItem('token');

  if (!token) {
    renderApp();
    return;
  }

  if (!isTokenValid(token)) {
    clearSession({ redirect: false });
    renderApp();
    return;
  }

  try {
    await loadUserInformation();
    renderApp();
  } catch (err) {
    console.error('Error handling token:', err);
    clearSession({ redirect: false });
    renderApp();
  }
};

const loadUserInformation = async () => {
  const unit = parseInt(localStorage.getItem('unit'));
  const res = await information();
  store.dispatch({ type: 'SET_LOGIN', payload: res.data });
  store.dispatch({ type: 'SET_UNIT_USER', payload: unit });
};

handleToken();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
